import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DisplayMode } from 'cbc-shared-lib';
import { Sgke131aResponseBasicInfo, Sgke131aResponseFeeMeisaiList, Sgke131aResponseRcvmnyFeeMeisai } from 'sg-api';

@Component({
  selector: 'app-sgke130d-rcvmny-fee-meisai',
  templateUrl: './sgke130d-rcvmny-fee-meisai.component.html',
  styleUrl: './sgke130d-rcvmny-fee-meisai.component.scss'
})
export class Sgke130dRcvmnyFeeMeisaiComponent implements OnInit, OnDestroy {
  /** モード区分 */
  @Input() mode: string;
  /** 基本情報 */
  @Input() basicInfo: Sgke131aResponseBasicInfo;
  /** 入金手数料明細 */
  @Input() rcvmnyFeeMeisai: Sgke131aResponseRcvmnyFeeMeisai;

  /** 登録ボタン押下Emitter */
  @Output() onClickFeeRegistEmitter = new EventEmitter();
  /** 編集ボタン押下Emitter */
  @Output() onClickFeeEditEmitter = new EventEmitter();

  /** モード区分_承認 */
  public MODE_APPROVE = DisplayMode.approve;

  /** 入金突合ステータス_未報告 */
  public RECONCILIATION_STATUSCODE_UNREPORTED = "0";
  /** 入金突合ステータス_報告済 */
  public RECONCILIATION_STATUSCODE_REPORTED = "1";
  /** 入金突合ステータス_承認済 */
  public RECONCILIATION_STATUSCODE_APPROVED = "2";

  /** データソース */
  dataSource: MatTableDataSource<Sgke131aResponseFeeMeisaiList>;
  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'fee',
    'feeMny',
  ];

  /**
   * 初期処理
   * 
   * @memberof Sgke130dRcvmnyFeeMeisaiComponent
   */
  ngOnInit(): void {
    if (this.rcvmnyFeeMeisai.feeMno != null) {

      // 手数料内容を出力順に並び替え
      const feeMeisaiList = this.rcvmnyFeeMeisai.feeMeisaiList.sort(
        (sourceObject, targetObject) =>
          sourceObject?.outputOrder - targetObject?.outputOrder
      );

      // Table表示データ作成
      this.dataSource = new MatTableDataSource<Sgke131aResponseFeeMeisaiList>(feeMeisaiList);
    }

  }

  /**
   * コンポーネントが破棄される際に呼び出されるライフサイクルフック
   * リソースの解放や購読の解除
   * 
   * @memberof Sgke130dRcvmnyFeeMeisaiComponent
   */
  ngOnDestroy(): void {
  }

  /**
   * 登録ボタン押下を親コンポーネントへ通知する処理
   *
   * @memberof Sgke130dRcvmnyFeeMeisaiComponent
   */
  onClickRegist(): void {
    this.onClickFeeRegistEmitter.emit();
  }

  /**
   * 訂正ボタン押下を親コンポーネントへ通知する処理
   *
   * @memberof Sgke130dRcvmnyFeeMeisaiComponent
   */
  onClickEdit(): void {
    this.onClickFeeEditEmitter.emit();
  }

  /**
   * 登録ボタン活性非活性判定
   *
   * @returns {boolean} true:非活性、false:活性
   * @memberof Sgke130dRcvmnyFeeMeisaiComponent
   */
  isResistButtonDisabled(): boolean {
    if (this.mode == this.MODE_APPROVE) {
      // 承認画面の場合、非活性
      return true;
    }

    if (this.rcvmnyFeeMeisai.feeMno != null) {
      // 手数料明細が存在する場合、非活性
      return true;
    }

    if (this.basicInfo.reconciliationStatuscode == this.RECONCILIATION_STATUSCODE_APPROVED ) {
      // 入金突合ステータスが承認済み場合、非活性
      return true;
    }

    return false;
  }

  /**
   * 訂正ボタン活性非活性判定
   *
   * @returns {boolean} true:非活性、false:活性
   * @memberof Sgke130dRcvmnyFeeMeisaiComponent
   */
  isEditButtonDisabled(): boolean {
    if (this.mode == this.MODE_APPROVE) {
      // 承認画面の場合、非活性
      return true;
    }

    if (this.rcvmnyFeeMeisai.feeMno == null) {
      // 手数料明細が存在しない場合、非活性
      return true;
    }

    if (this.basicInfo.reconciliationStatuscode == this.RECONCILIATION_STATUSCODE_APPROVED ) {
      // 入金突合ステータスが承認済みの場合、非活性
      return true;
    }

    return false;
  }

}
